import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { GateauxComponent } from './gateaux/gateaux.component';
import { MesFruitsComponent } from './mes-fruits/mes-fruits.component';
import { DetailsGateauxComponent } from './details-gateaux/details-gateaux.component';
import { GateauDejaMangeComponent } from './gateau-deja-mange/gateau-deja-mange.component';
import { BretonPipe } from './breton.pipe';
import { ClasseAmericainePipe } from './classe-americaine.pipe';
import { PanierComponent } from './panier/panier.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { FooterComponent } from './footer/footer.component';

@NgModule({
  declarations: [
    AppComponent,
  
    GateauxComponent,
    MesFruitsComponent,
    DetailsGateauxComponent,
    GateauDejaMangeComponent,
    BretonPipe,
    ClasseAmericainePipe,
    PanierComponent,
    NavBarComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
